import { APIClient } from "./apiCore";
import * as url from "./urls";
import { ProfileTypes } from "../data";
const api = new APIClient();

const createProfile = (payload: ProfileTypes) => {
  return api.create(url.CREATE_PROFILE, payload);
};

const updateProfile = (uploadedLogoUrl: string) => {
  const payload = { logoUrl: uploadedLogoUrl };
  const response: Promise<any> = api.create(url.UPDATE_PROFILE, payload);
  return response;
};

const getProfile = () => {
  const response: Promise<any> = api.get(url.GET_PROFILE);
  return response;
};

const uploadLogo = (formData: any) => {
  const response: Promise<any> = api.create(url.UPLOAD_LOGO, formData);
  return response;
};

export { createProfile, getProfile, uploadLogo, updateProfile };
